import { Box, Chip, Divider, Typography } from '@mui/material';
import React, { ReactNode } from 'react';

import { EControlPositionType, EPositionType, IEnrichedUniswapPosition } from '../../types/uniswapTokens';
import { RangeIndicator } from '../../components-yldr/RangeIndicator/RangeIndicator';
import { ListPoolIcon } from '../../modules/dashboard/lists/ListPoolIcon';
import { EMarketName } from '../../ui-config/marketsConfig';
import { EStrategyProvider } from '../../hooks/yldr/useAlmPoolQuery';
import { AlmMarketChip } from '../../ui-kit/AlmMarketChip';

interface ListMobileItemProps {
  children: ReactNode;
  position: IEnrichedUniswapPosition;
  almMarketName?: EStrategyProvider;
  isManual?: boolean;
  isAutomatic?: boolean;
  marketName?: EMarketName;
}

export const MobileItemWrapper = ({
  children,
  position,
  isManual,
  isAutomatic,
  almMarketName,
  marketName,
}: ListMobileItemProps) => {
  return (
    <Box>
      <Divider />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, p: 4 }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <ListPoolIcon
            iconSymbolTokenA={position.token0.iconSymbol}
            iconSymbolTokenB={position.token1.iconSymbol}
            marketName={marketName}
            size="large"
          />
          <Box sx={{ pl: 3, width: 'calc(100% - 16px)' }}>
            <Box sx={{ display: 'flex' }}>
              <Typography variant="main16" noWrap>
                {position.token0.symbol}/{position.token1.symbol}
              </Typography>
              {Boolean(position.fee) && position.type !== EPositionType.Pool && (
                <Typography variant="main16" color="text.tertiary" sx={{ pl: '4px' }}>
                  {position.fee}%
                </Typography>
              )}
            </Box>
            {position.type === EPositionType.Pool && (
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                {isAutomatic && <Chip label="ALM" />}
                {isManual && <Chip label="Manual" />}
              </Box>
            )}
            {position.lowerPosition && position.upperPosition && position.controlType !== EControlPositionType.AlmPosition && (
              <RangeIndicator
                lowerPosition={position.lowerPosition}
                upperPosition={position.upperPosition}
                currentPrice={position.poolPrice}
                symbolTokenA={position.token0.symbol}
                symbolTokenB={position.token1.symbol}
              />
            )}
            {position.controlType === EControlPositionType.AlmPosition && (
              <AlmMarketChip almMarketName={almMarketName} />
            )}
          </Box>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};
